import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';

import { ConnectWiseModule } from './connectwise/connectwise.module';
import { AutotaskModule } from './autotask/autotask.module';
import { MicrosoftTeamsModule } from './msteams/msteams.module';

import { CoreModule } from './core/core.module';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    CommonModule,
    HttpClientModule,
    FormsModule,
    ConnectWiseModule,
    AutotaskModule,
    MicrosoftTeamsModule,
    CoreModule.forRoot(),
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'counter', component: CounterComponent },
      { path: 'fetch-data', component: FetchDataComponent },
      {
        path: 'connectwise', loadChildren: () => import('./connectwise/connectwise.module').then(m => m.ConnectWiseModule),
        data: {
          privilege: 'User'
        }
      },
      {
        path: 'autotask', loadChildren: () => import('./autotask/autotask.module').then(m => m.AutotaskModule),
        data: {
          privilege: 'User'
        }
      },
      {
        path: 'msteams', loadChildren: () => import('./msteams/msteams.module').then(m => m.MicrosoftTeamsModule),
        data: {
          privilege: 'User'
        }
      },
    ])
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
